export default [
  {
    path: '/foundations/logos',
    name: 'foundations-logos',
    component: () => import('@/views/foundations/Logos.vue'),
    meta: {
      pageTitle: 'Logos',
      breadcrumb: [
        {
          text: 'Foundations',
        },
        {
          text: 'Logos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/foundations/spacing',
    name: 'foundations-spacing',
    component: () => import('@/views/foundations/Spacing.vue'),
    meta: {
      pageTitle: 'Spacing',
      breadcrumb: [
        {
          text: 'Foundations',
        },
        {
          text: 'Spacing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/foundations/typography',
    name: 'foundations-typography',
    component: () => import('@/views/foundations/Typography.vue'),
    meta: {
      pageTitle: 'Typography',
      breadcrumb: [
        {
          text: 'Foundations',
        },
        {
          text: 'Typography',
          active: true,
        },
      ],
    },
  },
  {
    path: '/foundations/colors',
    name: 'foundations-colors',
    component: () => import('@/views/foundations/Colors.vue'),
    meta: {
      pageTitle: 'Colors',
      breadcrumb: [
        {
          text: 'Foundations',
        },
        {
          text: 'Colors',
          active: true,
        },
      ],
    },
  },
  {
    path: '/foundations/iconography',
    name: 'foundations-iconography',
    component: () => import('@/views/ui/feather/Feather.vue'),
    meta: {
      pageTitle: 'Iconography',
      breadcrumb: [
        {
          text: 'Foundations',
        },
        {
          text: 'Iconography',
          active: true,
        },
      ],
    },
  },
]
